import { IAppThemeFactory } from "./IAppThemeFactory";
import { WordThemeFactory } from "./Word/WordThemeFactory";
import { OneNoteThemeFactory } from "./OneNote/OneNoteThemeFactory";
import { HostAppName } from "../../../backend/office-js/HostAppSettings";

//AppFactoryProducer will be used to create factory of Word/OneNote app on the basis of current host app name.
export class AppThemeFactoryProducer {
  private static instance: IAppThemeFactory | null = null;

  static GetInstance(hostAppName : String) {
    if (this.instance == null) this.instance = this.GetSDXAppFactory(hostAppName);

    return this.instance;
  }

  //required for Unit Testing.
  static ResetInstance() {
    this.instance = null;
  }

  private static GetSDXAppFactory(hostAppName : String) : IAppThemeFactory {
    switch (hostAppName) {
      case HostAppName.WORD:
          return new WordThemeFactory();
      case HostAppName.ONENOTE:
          return new OneNoteThemeFactory();
      default:
          throw new Error("Invalid app name provided while creating app theme factory");
    }
  }
}